<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                      Wallet                                          │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <div class="rewards-wallet" v-if="loaded">
        <h3 class="rewards-title">Your Wallet</h3>
        <template v-if="cards">
            <template v-if="cards.length">
                <table>
                    <tr>
                        <th>Gateway</th>
                        <th>Number</th>
                        <th>Card Holder</th>
                        <th>Expiration</th>
                        <th>Verified</th>
                        <th></th>
                    </tr>
                    <tr v-for="card in cards">
                        <td>{{ card.gatewayName }}</td>
                        <td>{{ card.cardNumber }}</td>
                        <td>{{ card.nameOnCard }}</td>
                        <td>{{ card.cardExpires }}</td>
                        <td>
                            <div v-if="card.isVerified" class="verified"></div>
                            <div v-else class="notVerified"></div>
                        </td>
                        <td>
                            <a href="#" @click="deleteCard">delete</a> <!-- Need to replace this with a trashcan icon -->
                        </td>
                    </tr>
                </table>
            </template>
            <template v-else>
                No wallet data found.
            </template>
        </template>
    </div>
</template>

<script>
    import { fetchJSON, postJSON } from "@/helpers/fetch"
    export default {
        name: 'Wallet',

        emits: ['loading', 'loaded', 'submitting', 'submitted'],

        data() {
            return {
                cards: null,
                loaded: false,

                submitting: false,
            }
        },
        mounted() {
            this.getWallet();
        },
        methods: {
            getWallet() {
                this.cards = null;

                this.$emit('loading')

                fetchJSON(`/api/members/GetWallet`)
                    .then(data => {
                        this.cards = data.cards;
                        this.loaded = true
                        this.$emit('loaded')
                    })
                    .catch(() => {
                        this.loaded = true
                        this.$emit('loaded')
                    })
            },

            deleteCard(walletId) {
                if (this.submitting) {
                    alert('Processing; please wait ...')
                }
                else {
                    this.$emit('submitting')
                    this.submitting = true

                    fetchJSON(`/api/members/DeleteWalletCard`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(walletId)
                    })
                        .then(() => {
                            //Handle deleteCard?
                        })
                        .finally(() => {
                            this.$emit('submitted')
                            this.submitted = false
                        })
                }
            }
        }
    }
</script>
